import React, { useEffect } from "react";
import "./index.css";
import img6 from "./images/2.jpg";
import LocationOnIcon from "@material-ui/icons/LocationOn";
import EmailIcon from "@material-ui/icons/Email";
import CallIcon from "@material-ui/icons/Call";
import { useForm } from "react-hook-form";
// import classNames from "classnames";
import Aos from "aos";
import "aos/dist/aos.css";

const Contact = () => {
  useEffect(() => {
    Aos.init({ duration: 1200 });
  }, []);

  const { register, handleSubmit, formState: { errors } } = useForm();
  const onSubmit = (data) => console.log(data);
  return (
    <div>
      <body>
        <section className="contact-form">
          <div className="container">
            <div className="form-wrapper">
              <div data-aos="fade-down" className="company-address">
                <div className="address-group">
                  <div className="contactIcon">
                    <LocationOnIcon fontSize="large" className="text-green" />
                  </div>

                  <h2 className="text-grey md-heading">Location</h2>
                  <p>#713343 Station Road, Kulti, Asansol</p>
                </div>
                <div className="address-group">
                  <div className="contactIcon">
                    <EmailIcon fontSize="large" className="text-green" />
                  </div>
                  <h2 className="text-grey md-heading">E-mail</h2>
                  <p>sonaradarsh1@gmail.com</p>
                </div>
                <div className="address-group">
                  <div className="contactIcon">
                    <CallIcon fontSize="large" className="text-green" />
                  </div>
                  <h2 className="text-grey md-heading">Call</h2>
                  <p>+91 9749012125</p>
                </div>
                <img src={img6} alt="Picture of company's image" />
              </div>
              <form
                data-aos="fade-up"
                className="form"
                autoComplete="off"
                onSubmit={handleSubmit(onSubmit)}
              >
                <h1 className="lg-heading text-black">Contact Us</h1>
                <p className="text-grey">
                  Let us know your questions, suggestions and concerns by
                  filling out the contact form below.
                </p>
                <div className="form-group">
                  <label htmlFor="fullname">Fullname</label>
                  <input
                    type="text"
                    autoComplete="off"
                    id="fullname"
                    name="fullname"
                    placeholder="Enter your Fullname"
                    {...register("fullname", { required: true, minLength:2,maxLength: 20 })}
                  />
                  <small className="text-red bold">
                  {errors.fullname?.type === 'required' && "Fullname name is required"}
                  {errors.fullname?.type === 'minLength' && "Fullname must be minimin 2 character"}
                  {errors.fullname?.type === 'maxLength' && "Fullname must be maximum 20 character"}
                  </small>
                </div>
                <div className="form-group">
                  <label htmlFor="email">E-mail</label>
                  <input
                    type="text"
                    autoComplete="off"
                    id="email"
                    name="email"
                    placeholder="Enter your email"
                    {...register("email",{ required: true, pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/ })}
                  />
                  <small className="text-red bold">
                  {errors.email?.type === 'required' && "Email name is required"}
                  {errors.email?.type === 'pattern' && "Please fill a valid Email"}
                  </small>
                </div>
                <div className="form-group">
                  <label htmlFor="phone">Phone</label>
                  <input
                    type="number"
                    autoComplete="off"
                    id="phone"
                    name="phone"
                    placeholder="Enter your number"
                    {...register("phone",{ required: true, minLength:10, maxLength: 10 })}
                  />
                  <small className="text-red bold">
                  {errors.phone?.type === 'required' && "Phone Number name is required"}
                  {errors.phone?.type === 'maxLength' && "Please fill a valid Phone Number"}
                  {errors.phone?.type === 'minLength' && "Please fill a valid Phone Number"}
                  </small>
                </div>
                <div className="form-group">
                  <label htmlFor="message">Message</label>
                  <input
                    className="textarea"
                    type="text"
                    autoComplete="off"
                    id="message"
                    placeholder="Type your message"
                    {...register("message",{ required: true, minLength: 10 })}
                  />
                  <small className="text-red bold">
                  {errors.message?.type === 'required' && "This filled can't be empty"}
                  {errors.message?.type === 'minLength' && "Type more than 10 Letters"}
                  </small>
                </div>
                <button type="submit" className="form-btn">
                  Submit
                </button>
              </form>
            </div>
          </div>
        </section>
      </body>
    </div>
  );
};

export default Contact;
